import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { MdDataUsage, MdPhoneAndroid, MdBuildCircle, MdSms } from "react-icons/md";
import Layout from "../components/Layout";

const features = [
  {
    Icon: MdDataUsage,
    title: "Data Usage",
    description: "Check SIM data usage and plan details instantly.",
    path: "/data-usage",
    label: "Get Data Usage",
  },
  {
    Icon: MdPhoneAndroid,
    title: "Device Info",
    description: "Retrieve device details for any mobile number.",
    path: "/device-info",
    label: "Get Device Info",
  },
  {
    Icon: MdBuildCircle,
    title: "Device Diagnose",
    description: "Fetch RADIUS attributes for device diagnostics.",
    path: "/device-diagnose",
    label: "Run Diagnostics",
  },
  {
    Icon: MdSms,
    title: "Send SMS",
    description: "Send an SMS message to any mobile number.",
    path: "/send-sms",
    label: "Send SMS",
  },
];

const HomePage = () => {
  const navigate = useNavigate();
  const user = useAuth();

  useEffect(() => {
    if (user === null) return;
    if (!user) navigate("/");
  }, [user, navigate]);

  return (
    <Layout title="Dashboard">
      {/* Welcome banner */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold" style={{ color: "#ffffff" }}>
          Welcome back{user?.displayName ? `, ${user.displayName.split(" ")[0]}` : ""}
        </h2>
        <p className="mt-1" style={{ color: "#888888" }}>What would you like to do today?</p>
      </div>

      {/* Feature cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
        {features.map(({ Icon, title, description, path, label }) => (
          <div
            key={path}
            className="rounded-2xl p-6 flex flex-col"
            style={{ backgroundColor: "#1c1c1c", border: "1px solid #2a2a2a" }}
          >
            <div
              className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
              style={{ backgroundColor: "#ffc20e22" }}
            >
              <Icon className="text-2xl" style={{ color: "#ffc20e" }} />
            </div>
            <h3 className="text-base font-semibold mb-1" style={{ color: "#ffffff" }}>{title}</h3>
            <p className="text-sm flex-1 mb-5" style={{ color: "#888888" }}>{description}</p>
            <button
              onClick={() => navigate(path)}
              className="w-full py-2.5 text-sm font-semibold rounded-xl transition-colors"
              style={{ backgroundColor: "#ffc20e", color: "#000000" }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#e6ae00"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#ffc20e"; }}
            >
              {label}
            </button>
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default HomePage;
